import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class SaveButtonStateService {
	private _saving$: Promise<boolean> = Promise.resolve(false);

	get saving$(): Promise<boolean> {
		return this._saving$;
	}

	setSaving(isSaving: boolean) {
		this._saving$ = Promise.resolve(isSaving);
	}
}
